import { getEmployerBankAccounts } from "../../../../../../legacyComponents/util/helperFunctions"
import { options } from "../util"

export default function getInitialValues(props) {
	const { employer } = props
	const { billingAccount, reimbursementAccount } = getEmployerBankAccounts(employer)

	return {
		bank: (() => {
			if (reimbursementAccount?.id) {
				const { routingNumber, nickname } = reimbursementAccount
				return { ...reimbursementAccount, displayName: `${routingNumber || "000000000"} - ${nickname}` }
			} else {
				return options.nullOption()
			}
		})(),

		bankName: reimbursementAccount?.bankName,
		nickname: reimbursementAccount?.nickname,
		accountType: reimbursementAccount?.accountType,
		accountNumber: reimbursementAccount?.accountNumber,
		bankAccountId: reimbursementAccount?.id || null,
		verifiedTs: reimbursementAccount?.verifiedTs || null,
		isBillingAccount: (() => {
			if (reimbursementAccount?.id) {
				if (reimbursementAccount?.id === billingAccount?.id) return "Yes"
				else return "No"
			} else return ""
		})()
	}
}
